import {GridItem, GridLayout} from 'grid-layout-plus'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp
    .component('GridLayout', GridLayout)
    .component('GridItem', GridItem)
});